export const UPDATE_SURVEY = "UPDATE_SURVEY";
export const SET_SURVEY_ID = "SET_SURVEY_ID";
export const RESET_SURVEY_ID = "RESET_SURVEY_ID";
export const SET_SURVEY_ANSWERS = "SET_SURVEY_ANSWERS";
export const UPDATE_ANSWERS = "UPDATE_ANSWERS";
export const UPDATE_SURVEY_ANSWERS = "UPDATE_SURVEY_ANSWERS";
export const UPDATE_SURVEY_SCORE = "UPDATE_SURVEY_SCORE";
export const RESET_STATE = "RESET_STATE";



// WEBPACK FOOTER //
// ./src/store/survey/mutations.js